@if(mode === 'full' && isAdmin) {
<div class="card">
  <h5>Manual weekly settlement</h5>
  @if(isCurrent) {
    <p>Select the order completion dates to settle. Only orders not already assigned to a transaction are included. Dates use your local timezone.</p>
    <div class="tw-flex tw-flex-wrap tw-gap-4 tw-items-end">
      <label>From <input type="date" [(ngModel)]="periodStart" (ngModelChange)="previewPeriod = {}" /></label>
      <label>Through <input type="date" [(ngModel)]="periodEnd" (ngModelChange)="previewPeriod = {}" /></label>
      <p-button label="Preview period" (click)="preview()" [disabled]="loading" />
      <p-button label="Previous week (Mon�Sun)" (click)="previousWeek()" [disabled]="loading" />
    </div>
  }
  <div class="tw-flex tw-flex-wrap tw-gap-4 tw-items-end tw-mt-4">
    <label>Actual total paid (�)<input type="number" min="0" step="0.01" [(ngModel)]="paidAmount" /></label>
    <label>Actual payment date (leave empty for pending)<input type="datetime-local" [(ngModel)]="paidDate" /></label>
    <label>Payment reference / notes<input type="text" pInputText [(ngModel)]="paymentReference" /></label>
    @if(isCurrent) {
      <p-button [label]="paidDate ? 'Record actual payment' : 'Create pending settlement'" (click)="recordSettlement()"
        [disabled]="loading || !previewPeriod.periodStart || !transact?.Quantity" [loading]="loading" />
    }
  </div>
  @if(!isCurrent && transact) {
    <p>Enter the total paid for this settlement, including earlier payments. This also corrects an existing record.</p>
    <p-button label="Save actual total paid" (click)="savePayment()" [disabled]="loading" [loading]="loading" />
  }
  @if(error) { <p role="alert">{{error}}</p> }
</div>
}
@if(!transact){
<div class="tw-flex tw-items-center tw-justify-center" [class.tw-h-64]="mode!='simple'">
  @if(loading){<p-progressSpinner></p-progressSpinner>}
  @else {<h3>No unprocessed transaction found.</h3>}
</div>
}
@else{

@switch (mode) {

@case ('simple') {
<div class="tw-flex tw-justify-between">
  <div class="field">
    <label htmlFor="quantity">Quantity</label>
    <span class="tw-font-bold">{{transact.Quantity}} order(s)</span>
  </div>
  <div class="field">
    <label htmlFor="payable">Payable</label>
    <span class="tw-font-bold">{{transact.TotalDue ?? transact.Payable|currency:'&pound;'}}</span>
  </div>
  @if(transact.PreviousBalance) {
  <div class="field">
    <label>Payable breakdown</label>
    <span>Unprocessed: {{transact.Payable | currency:'GBP'}} + Previous balance: {{transact.PreviousBalance | currency:'GBP'}}</span>
  </div>
  }
  @if(transact.Status=='New'){
  <div class="field">
    <p-button label="Details" icon="pi pi-money-bill" class="tw-bg-green-500 tw-text-white"
      [routerLink]="[basePath,'transact', businessId, transact.Status=='New'?'current':transact.Id]"></p-button>
  </div>
  }
</div>
}

@case ('full') {
<div class="card">
  <h5>Transact Details</h5>
  @if(transact.PeriodStart) {
    <p>Settlement period: {{transact.PeriodStart | date:'mediumDate'}} � {{transact.PeriodEnd | date:'mediumDate'}} (end exclusive)</p>
  }
  @if(!isCurrent) {
    <p>Actual paid: <strong>{{transact.RecordedPaidAmount | currency:'GBP'}}</strong>
      | Remaining: <strong>{{transact.RemainingAmount | currency:'GBP'}}</strong></p>
  }
  @if(transact.PaidDate) { <p>Paid: {{transact.PaidDate | date:'short'}}</p> }
  @if(transact.PaymentReference) { <p>Reference: {{transact.PaymentReference}}</p> }
  <div class="tw-flex tw-justify-between">
    <div class="field">
      <label htmlFor="quantity">Quantity</label>
      <span class="tw-font-bold">{{transact.Quantity}} order(s)</span>
    </div>
    <div class="field">
      <label htmlFor="payable">Payable</label>
      <span class="tw-font-bold">{{transact.Payable|currency:'&pound;'}}</span>
    </div>
    <div class="field">
      <label htmlFor="withdraw">Withdraw</label>
      <p-button label="Withdraw" icon="pi pi-money-bill" (click)="withdraw()" class="tw-bg-green-500 tw-text-white"
        [disabled]="transact.Status!='New' || transact.Payable <= 0 || !!periodStart || !!periodEnd" [loading]="loading"></p-button>
    </div>
    <div class="field">
      <label htmlFor="withdraw" class="tw-font-bold">Status</label>
      <span class="tw-font-bold">{{transact.Status}}</span>
    </div>
  </div>
</div>
<p-table [value]="transact.Articles" [rowHover]="true" [loading]="loading">
  <ng-template pTemplate="header">
    <tr>
      <th>Payment Type</th>
      <th>Quantity</th>
      <th>Total Order Amount</th>
      <th>Total Commission Amount</th>
      <th>Total Used Balance</th>
      <th>Total Main Credit</th>
      <th>Total Business Credit</th>
      <th>Total Service Fee</th>
      <th>Payable</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-article>
    <tr>
      <td class="tw-font-bold">
        {{article.Title}}
      </td>
      <td>{{article.Quantity}} order(s)</td>
      <td>{{article.TotalPayableAmount|currency:'&pound;'}}</td>
      <td>{{article.TotalCommissionAmount|currency:'&pound;'}}</td>
      <td>{{article.TotalUsedBalance|currency:'&pound;'}}</td>
      <td>{{article.TotalMainCredit|currency:'&pound;'}}</td>
      <td class="tw-bg-slate-100">{{article.TotalBusinessCredit|currency:'&pound;'}}</td>
      <td>{{article.TotalOnlinePaymentFee|currency:'&pound;'}}</td>
      <td class="tw-font-bold">{{article.Total|currency:'&pound;'}}</td>
    </tr>
  </ng-template>
</p-table>

<h5>Orders</h5>
<p-table [value]="orders" [rowHover]="true" dataKey="id" [rows]="limit" [loading]="loading" [rowHover]="true"
  styleClass="p-datatable-gridlines" [paginator]="true"  [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
  [totalRecords]="total" responsiveLayout="scroll" [lazy]="true" (onLazyLoad)="loadOrders($event)">
  <ng-template pTemplate="header">
    <tr>
      <th>Order Number</th>
      <th>Type</th>
      <th>Payment</th>
      <th>Order Time</th>
      <th>Payment</th>
      <th>Commission Amount</th>
      <th>Used Balance</th>
      <th>Main Credit</th>
      <th>Business Credit</th>
      <th>Service Fee</th>
      <th>Restaurant Payable</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-order>
    <tr>
      <td class="tw-font-bold">{{order.Number}}</td>
      <td>{{order.Type}}</td>
      <td>
        {{order.Payment?.PaymentMethod || (order.Payment?.IsCash ? 'Cash' : 'Not specified')}}
      </td>
      <td>{{order.CompletedTime|date:'short'}}</td>
      <td>{{order.PayableAmount|currency:'&pound;'}}</td>
      <td>{{order.CommissionAmount|currency:'&pound;'}}</td>
      <td>{{order.UsedBalance|currency:'&pound;'}}</td>
      <td>{{order.MainCredit|currency:'&pound;'}}</td>
      <td class="tw-bg-slate-100">{{order.BusinessCredit|currency:'&pound;'}}</td>
      <td>{{order.OnlinePaymentFee|currency:'&pound;'}}</td>
      <td class="tw-font-bold">{{order.TransactAmount|currency:'&pound;'}}</td>
    </tr>
  </ng-template>
</p-table>
}
}

}